<template>
  <div class="cmp cmp-evaluate-task-teacher">
    <cmpCard :showFooter="false">
      <div slot="header">
        <el-row type="flex">
          <strong>任务评价 {{ data.nodeName }}</strong>
        </el-row>
      </div>
      <div slot="body">
        <div class="students-list">
          <template v-for="(v, i) in myTaskEvaluates">
            <div v-if="v.type === 'seat'" class="students-item students-item-empty" :key="i"></div>
            <studentCard3
              v-else
              class="students-item"
              :data="v"
              :key="i"
              @update="getTeacherTaskEvaluate"
            ></studentCard3>
          </template>
          <div v-if="myTaskEvaluates.length === 0" class="nodata nodata-rates"></div>
        </div>
      </div>
    </cmpCard>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import cmpCard from "@/components/cmpCard.vue";
import studentCard3 from "./student-card-3.vue";
import publicUrl from "@/assets/js/interface";
import utils from "@/assets/js/utils.js";

export default {
  name: "cmp-evaluate-task-teacher",
  components: {
    studentCard3,
    cmpCard,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      taskEvaluates: [],
      loadingCount: 0,
    };
  },
  computed: {
    ...mapGetters({
      workTypeDict: "workTypeDict",
      classActive: "classmanagement/classActive",
    }),
    myTaskEvaluates() {
      let taskEvaluates = utils.deepCopy(this.taskEvaluates);
      let arr = taskEvaluates.map((item) => {
        let result = {};
        let { correctNum, totalNum } = item.quizRecord || {};
        result.quizRecord = {
          title: "课堂小测",
          value: "",
          content: correctNum === -1 ? "未提交" : `正确${correctNum || 0}/${totalNum || 0}`,
        };
        result.questionnaire = {
          title: "课堂问卷",
          value: item.questionnaireNum,
          content: item.questionnaireNum === -1 ? "未提交" : `提交${item.questionnaireNum || 0}次`,
        };
        // result.topic = {
        //   title: "主题讨论",
        //   value: item.topicNum,
        //   content: item.topicNum === -1 ? "未发送" : `发送${item.topicNum || 0}条`,
        // };
        // result.groupChat = {
        //   title: '组内聊天', value: item.groupChatNum,
        //   content: item.groupChatNum === -1 ? '未发送' : `发送${item.groupChatNum || 0}条`,
        // }
        let workRecordStar = item.workRecordStar || [];
        let content = "未评价";
        if (workRecordStar.length) {
          content = `${Math.floor(workRecordStar.reduce((a, b) => a + b) / workRecordStar.length) || 0}星`;
        }
        result.workRecord = {
          title: "课堂作业",
          value: "",
          // content: item.workRecordStar === -1 ? '未评价' : `${item.workRecordStar || 0}星`,
          content,
        };
        result.teacherStar = item.teacherStar || 0;
        result.studentName = item.studentName || "";
        result.headPhoto = item.headPhoto || "00";
        result.source = item.source;
        result.studentId = item.studentId;
        result.taskId = item.taskId;
        result.taskName = item.taskName;
        return result;
      });
      return utils.listWith(arr, 3);
    },
  },
  created() {
    if (this.$route.query.projectId) {
      this.getTeacherTaskEvaluate();
    }
  },
  methods: {
    getTeacherTaskEvaluate() {
      this.loadingCount++;
      this.taskEvaluates = [];
      this.$ajax
        .get(publicUrl.taskEvaluate, {
          params: {
            // taskId: this.$route.query.taskId,
            taskId: this.data.id,
            classId: this.classActive.id,
          },
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.taskEvaluates = res.data.data || [];
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.cmp-evaluate-task-teacher {
  .students-list {
    display: flex;
    flex-wrap: wrap;
    .students-item-empty {
      height: 1px;
      width: 368px;
      margin: 0 auto;
      visibility: hidden;
    }
  }
}
</style>
